export default {
  'discount.title': '折扣',

  'discount.field.name': '折扣名',
  'discount.field.type': '类型',
  'discount.field.foreign_name': '折扣名(中文)',
  'discount.field.discount_type': '折扣类型',
  'discount.field.discount': '折扣',
  'discount.field.creator': '创建者',
  'discount.field.note': '备注',
  'discount.field.discountCategory': '折扣类型',
  'discount.field.associatedRoles': '关联的角色',
  'discount.field.operation': '操作',

  'discount.name.isRequired': '请输入折扣名',
  'discount.type.isRequired': '请选择类型',
  'discount.foreign_name.isRequired': '请输入折扣(中文名)',
  'discount.discount_type.isRequired': '请选择折扣类型',
  'discount.discount.isRequired': '请填写折扣值',

  'discount.edit.title': '编辑折扣',
  'discount.create.title': '创建折扣',

  'discount.deletion.promptTitle': '折扣删除提示',
  'discount.deletion.promptContent': '确认要删除此折扣吗？',

  'discount.deletion_category.promptContent': '确认要删除此折扣分类吗？',

  'discount.discount_category.title': '折扣分类',
  'discount.discount_category.table_title': '添加你的 “折扣分类”',

  'discount.link.discount_category.head': '定义折扣分类',
  'discount.link.discount_category.here': ' 这里 ',
  'discount.link.discount_category.foot': '，方便在报表里按折扣分类统计。',
};
